<template>
	<div
		:class="[
			'group relative flex translate-y-0 flex-col rounded-[4px] bg-gradient-to-r from-slate-400 to-slate-400/25 duration-300 hover:-translate-y-1'
		]"
	>
		<div
			:class="[
				'absolute bottom-0 start-0 top-0 w-1 rounded-s-[4px] duration-300',
				category?.color ? '' : 'bg-primary'
			]"
			:style="{
				backgroundColor: category?.color
			}"
		></div>
		<div class="z-[1] flex flex-grow flex-col border-y-2 border-e-2 border-s-[4px] border-transparent">
			<div class="bg-white flex flex-grow flex-col rounded-e-[3px] px-4 pb-4 pt-4">
				<span class="text-slate-900 text-2xl font-bold">
					{{ $stringUtil.getLocalText(post.title) || "~" }}
				</span>
				<div class="text-slate-700 me-1 mt-4 flex items-center text-sm">
					<span class="">
						{{ $t("start_reading") }}
					</span>
					<Icon name="mdi:chevron-left" class="h-6 w-6" />
				</div>
				<div v-if="readTime" class="text-slate-600 mt-8 flex items-center self-end text-xs">
					<Icon name="mdi:clock-outline" class="me-1 h-[18px] w-[18px]" />
					<span class="font-medium">
						{{ $t("read_time_n", { n: $t("n_minutes", { n: readTime }, readTime) }) }}
					</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import type { Post } from "~/models/post"

const categoryStore = useCategoryStore()

const props = defineProps<{
	post: Post
}>()

const category = computed(() => categoryStore.categories?.find((c) => props.post.category_ids.includes(c.id)))

const readTime = computed(() => Math.ceil((props.post.read_time || 1) / 60))
</script>
